import './wallet-list.scss';

import PropTypes from 'prop-types';
import React from 'react';
import { NavLink, useParams } from 'react-router-dom';

import { WalletListCarousel } from '.';
import { WalletCard } from './wallet-card';

const WalletList = ({ wallets, isLoading, baseUrl, getCardExtra }) => {
  return (
    <>
      <div className="walletList">
        {!wallets.length && isLoading && (
          <>
            <LoadingWallet />
            <LoadingWallet />
            <LoadingWallet />
          </>
        )}
        {wallets && (
          <WalletListCarousel>
            {wallets.map((wallet) => (
              <SingleWallet wallet={wallet} key={wallet.id} baseUrl={baseUrl} getCardExtra={getCardExtra} />
            ))}
          </WalletListCarousel>
        )}
      </div>
    </>
  );
};

WalletList.defaultProps = {
  wallets: [],
  isLoading: false
};
WalletList.propTypes = {
  wallets: PropTypes.array,
  isLoading: PropTypes.bool,
  baseUrl: PropTypes.string,
  getCardExtra: PropTypes.func
};

const SingleWallet = ({ wallet, baseUrl, getCardExtra, ...props }) => {
  const { tab } = useParams();
  const {
    currency: { slug }
  } = wallet;
  const linkTo = `${baseUrl}/${!tab ? 'all' : tab}/${slug?.toLowerCase()}`;
  const extra = getCardExtra ? getCardExtra(wallet) : null;

  return (
    <NavLink to={linkTo} exact {...props}>
      <WalletCard wallet={wallet} extra={extra} />
    </NavLink>
  );
};

const LoadingWallet = () => {
  return (
    <NavLink className="wallet loading" to="/wallets/empty" exact>
      <span className="wallet__logo">
        <div className="bar"></div>
      </span>
      <span className="wallet__name">
        <span className="bar"></span>
      </span>
      <p className="wallet__balance">
        <span className="bar"></span>
      </p>
    </NavLink>
  );
};

SingleWallet.propTypes = {
  wallet: PropTypes.object,
  baseUrl: PropTypes.string,
  getCardExtra: PropTypes.func
};

export { WalletList };
